import type { IReportDataSetter, IReportDataGetter } from './interfaces';

/**
 * Represents a data model class for the report.
 */
export class ReportData implements IReportDataSetter, IReportDataGetter {
  private _data: Map<string, unknown> = new Map();

  /**
   * Sets the value of a report data item.
   * @param key - The key of the report data item.
   * @param value - The value to be set.
   */
  public setReportValue(key: string, value: unknown): void {
    this._data.set(key, value);
  }

  /**
   * Gets the value of a report data item.
   * @param key - The key of the report data item.
   * @returns The value of the report data item.
   * @throws Error if the report data item with the specified key is not found.
   */
  public getReportValue<T>(key: string): T {
    const data = this._data.get(key);
    if (data === undefined) {
      throw new Error(`Report data with key ${key} not found`);
    }
    return data as T;
  }

  /**
   * Checks if the report data item with the specified key exists.
   * @param key - The key of the report data item.
   * @returns True if the report data item exists, false otherwise.
   */
  public hasReportValue(key: string): boolean {
    return this._data.has(key);
  }
}
